import React from 'react'
import { SetItemPlusMinus, SequenceItemUpDown,  } from '../ManageSetsComponents'
import { Link } from 'react-router-dom'

/*
  <SetItemRow 
    activeItems={activeItems}
    contentType={item.contentType}
    itemType={item.itemType}
    question={item.question}
    name={item.name}
    itemId={item.itemId}
    key={`item${item.itemId}`}
    handleAddContentToSet={props.handleAddContentToSet}
    handleRemoveContentFromSet={props.handleRemoveContentFromSet}
    arrows={'up' | 'down' | 'both'}
    itemBefore={itemBefore}
    itemAfter={itemAfter}
  />
*/

export default function SetItemRow ({
  activeItems, 
  itemId, 
  sequenceMode,
  contentType, 
  setType,
  name, 
  itemType, 
  question, 
  handleAddContentToSet, 
  handleRemoveContentFromSet, 
  arrows, 
  itemBefore, 
  itemAfter, 
  handleChangeSequence,
}) {
  return (
    <tr className={activeItems[itemId] && !sequenceMode ? 'bg-info m2selected-node' : ''}>
      <td>{contentType ? contentType : ''}</td>
      <td>{setType ? setType : ''}</td>
      <td>
        {name && contentType !== 'Item' 
          ? <Link to={`/content/sets/${itemId}?pane=2`}>{name}</Link> 
          : (name ? name : '')}
      </td>
      <td>{itemType ? itemType : ''}</td>
      <td>{question ? `${question.substring(0, 50)}...` : ''}</td>
      <td>
        {!sequenceMode 
          ? <SetItemPlusMinus 
              plusMinus={activeItems[itemId] ? 'minus' : 'plus'} 
              handleAddContentToSet={handleAddContentToSet}
              itemId={itemId}
              handleRemoveContentFromSet={handleRemoveContentFromSet}
            />
          : <SequenceItemUpDown
              arrows={arrows}
              itemBefore={itemBefore}
              itemAfter={itemAfter}
              handleChangeSequence={handleChangeSequence}
              itemId={itemId}
            />
          }
      </td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemRow.js